import type { FaireProductEntity } from "../../entity_types/product";

export const p_2mvsurueur: FaireProductEntity = {
  token: "p_2mvsurueur",
  type: "product",
  name: "Sea Salt Sun Beach Travel Make Up Pouch",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/957c00e8bbc0afbb12bcb51a079090bb272ff9f33a9151497ec7cdf4845de6d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c684dbd885efa622fc4db98ba210653c9aefcfe02cd3afade63f4c42e8941ca.jpeg"
  ],
  priceDollars: 7.5,
  description: "Our cosmetic bags make the cutest little pouch for all your makeup essentials! Perfect for travel, these trendy makeup bags can not only store your cosmetics but can serve as an everyday bag for your passport, iPod, headphones, cell phone, pencils, sunglasses and keys. These adorable travel bags make great Valentine's Day and Mother's Day gifts!\n\n• Material: 100% Cotton Canvas Fabric.\n• Size: 9\" W x 6\" H.\n\n• Reusable and Eco-friendly.\n• Made in the USA.\n\n• Spot clean with warm water and mild detergent (do not machine wash)",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:43.637Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
